import { $t } from '@/i18n';
import { isNull, isUndefined, keyBy } from 'lodash';
const operatorList = [
    {
        op: 'eq',
        dbOp: '=',
    },
    {
        op: 'noteq',
        dbOp: '!=',
    },
    {
        op: 'gt',
        dbOp: '>',
    },
    {
        op: 'gte',
        dbOp: '>=',
    },
    {
        op: 'lt',
        dbOp: '<',
    },
    {
        op: 'lte',
        dbOp: '<=',
    },
    {
        op: 'contains',
        dbOp: '%%',
    },
    {
        op: 'startswith',
        dbOp: '=%',
    },
    {
        op: 'endswith',
        dbOp: '%=',
    },
    {
        op: 'notcontains',
        dbOp: '!%',
    },
];
const operatorMap = keyBy(operatorList, 'op');
export function toFilterArray(filter, options) {
    if (!filter)
        return [];
    if (Array.isArray(filter) || typeof filter === 'string')
        return filter;
    const { nullable = false } = options || {};
    const filterArray = [];
    Object.entries(filter).forEach(([key, value]) => {
        if ((!nullable && isNull(value)) || isUndefined(value)) {
            return;
        }
        const { field, operator } = getFieldAndOpByKey(key);
        const dbOp = operatorMap[operator]?.dbOp || '=';
        if (dbOp) {
            filterArray.push({
                k: field,
                o: dbOp,
                v: value,
            });
        }
    });
    return filterArray;
}
/**
 *  转成 a="b"&c=1 的字符串
 * @param _filter
 */
export function toFilterExpr(filter, type = 'and', options) {
    if (typeof filter === 'string') {
        return filter;
    }
    const filterArray = toFilterArray(filter, options);
    if (!filterArray.length)
        return '';
    return filterArray
        .map(({ k, o, v }) => {
        const valueString = JSON.stringify(v);
        return `${k}${o}${valueString}`;
    })
        .join(type === 'and' ? '&' : '|');
}
export function toNestedFilterExpr(filter) {
    if (!filter)
        return '';
    const walk = (obj, type) => {
        const logicType = getAndOrType(obj);
        if (logicType) {
            const array = obj[`${logicType}`];
            if (!Array.isArray(array)) {
                throw new Error($t('k_38327a82'));
            }
            if (!array)
                return '';
            const expressions = array
                .map(item => walk(item, logicType))
                .filter(Boolean)
                .map(expr => `(${expr})`);
            return expressions.join(logicType === 'and' ? '&' : '|');
        }
        const expressions = toFilterExpr(obj, type);
        return expressions;
    };
    return walk(filter);
}
function getAndOrType(obj) {
    if (obj.and && obj.or) {
        throw new Error($t('k_19aebe28'));
    }
    if (obj.and) {
        return 'and';
    }
    if (obj.or) {
        return 'or';
    }
    return null;
}
const operatorRegex = new RegExp(`__(${operatorList.map(op => op.op).join('|')})$`);
function getFieldAndOpByKey(key) {
    const match = key.match(operatorRegex);
    if (match) {
        return {
            field: key.substring(0, match.index),
            operator: match[1],
        };
    }
    // 如果没有匹配到操作符，返回字段名和默认操作符 'eq'
    return {
        field: key,
        operator: 'eq',
    };
}
